<template>
  <!-- 确认订单头部 -->
  <div class="order-header">
    <van-nav-bar title="请填写收货地址" left-arrow @click-left="onClickLeft">
      <template #left>
        <van-icon name="arrow-left" color="#666666" />
      </template>
    </van-nav-bar>
    <van-form @submit="onSubmit">
      <van-field
        v-model="form.receiver"
        label="收件人"
        clearable
        placeholder="请输入收件人姓名"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="form.mobile"
        label="手机号"
        clearable
        placeholder="请输入收件人手机号"
        type="tel"
        :rules="[{ pattern, message: '' }]"
      />
      <van-field
        v-model="form.address_text"
        is-link
        readonly
        label="地区"
        placeholder="请选择所在地区"
        :rules="[{ required: true, message: '' }]"
        @click="pickerShow = true"
      />

      <van-popup v-model="pickerShow" round position="bottom">
        <van-cascader
          v-model="cascaderValue"
          title="请选择所在地区"
          :options="district"
          name="qwe"
          :field-names="fieldNames"
          @close="pickerShow = false"
          @finish="pickerFinish"
        ></van-cascader>
      </van-popup>
      <van-field
        v-model="form.detail_address"
        label="详细地址"
        clearable
        placeholder="请输入详细地址"
        :rules="[{ required: true, message: '' }]"
      />
      <div style="margin-top:.6rem">
        <van-cell center title="设为默认地址">
          <template #right-icon>
            <van-switch v-model="form.is_default" size="24" active-color="#EE2E2E " />
          </template>
        </van-cell>
      </div>
      <div class="bottom_btn">
        <van-button block type="info" native-type="submit" color="#EE2E2E">保存</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { getDistrict, editAddress } from '@/api/ePayPro.js'
import { Cascader, Toast } from 'vant'
export default {
  components: {
    [Cascader.name]: Cascader
  },
  data () {
    return {
      district: [],
      cascaderValue: '',
      pattern: /^1[3|4|5|7|8|6|9][0-9]\d{8}$/,
      pickerShow: false,
      fieldNames: { text: 'name', value: 'id', children: 'children' },
      form: {
        receiver: '',
        mobile: '',
        province_id: '',
        city_id: '',
        detail_address: '',
        county_id: '',
        address_text: '',
        is_default: false

      }
    }
  },
  computed: {
    completeAddress (e) {
      return function (e) {
        return '' + e.province + e.city + e.county + e.detail_address
      }
    }
  },
  beforeCreate () {
    document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
  },
  created () {
    this.getData()
    if (this.$route.query.address.id) {
      this.form = this.$route.query.address
      this.form.address_text = this.form.province + '-' + this.form.city + '-' + this.form.county
      this.cascaderValue = this.form.county_id
      this.form.is_default = !!this.form.is_default
    }
  },
  methods: {
    // 返回
    onClickLeft () {
      this.$router.go(-1)
    },
    pickerFinish (obj) {
      console.log(obj ,' --- obj ----');
      // console.log(obj.selectedOptions.length ,' --- obj.selectedOptions.length ----');
      // console.log(obj.selectedOptions ,' --- obj.selectedOptions ----');
      // console.log(this.cascaderValue)
      if (obj.selectedOptions.length > 0) {
        if (obj.selectedOptions.length  === 1) {
          this.form.address_text = obj.selectedOptions[0].name 
          this.form.province_id = obj.selectedOptions[0].id
          this.form.city_id = ''
          this.form.county_id = ''
          this.pickerShow = false
        }
        else if (obj.selectedOptions.length === 2) {
          this.form.address_text = obj.selectedOptions[0].name + '-' + obj.selectedOptions[1].name
          this.form.city_id = obj.selectedOptions[1].id
          this.form.county_id = ''
          this.pickerShow = false
        }
        else if (obj.selectedOptions.length === 3) {
          this.form.address_text = obj.selectedOptions[0].name + '-' + obj.selectedOptions[1].name + '-' + obj.selectedOptions[2].name
          this.form.province_id = obj.selectedOptions[0].id
          this.form.city_id = obj.selectedOptions[1].id
          this.form.county_id = obj.selectedOptions[2].id
          this.pickerShow = false
        }
      }
    },
    // 获取地址列表
    getData () {
      getDistrict({}).then((res) => {
        this.district = res.result.map(item => {
          const arrkey = Object.keys(item.children)
          item.children = arrkey.map(i => item.children[i])
          return item
        })
      })
    },
    // 提交保存地址
    onSubmit (e) {
      const postObj = {}
      Object.assign(postObj, this.form)
      if (postObj.is_default) {
        postObj.is_default = 1
      } else {
        postObj.is_default = 0
      }
      editAddress(postObj).then(res => {
        Toast.success('成功')
        this.$router.go(-1)
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.bottom_btn {
  width: 100%;
  position: absolute;
  bottom: 0%;
  left: 0;
}
</style>
